import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import moment from "moment";
import { Tooltip } from "primereact/tooltip";
import { Chip } from "primereact/chip";

import { InputSwitchField } from '../../../helpers'

import "../index.css"

import CheckInImg from '../../../images/checkin_new.png'
import CheckOutImg from '../../../images/checkout_new.png'
import RefreshImg from '../../../images/refresh.jpg'
import userImage from "../../../images/exception_role.png"

import { insertProcessLineStatus, updateProcessLineCheckInStatus } from '../../../services/api/processLineStatus'
import { getProcessLineItemsByProcessLineId } from '../../../services/api/processLineItems';
import { updateProcessLineStatus } from '../../../services/redux/reducers/processLineStatus/processLineStatus';
import { updateProcessLineItems, updateVerifiedPIItems } from '../../../services/redux/reducers/processLineItems/processLineItems';
import { raiseToast } from '../../../services/redux/reducers/toast/toast';

import { DATE_TIME_FORMAT } from "../../../constants"
import { getFullName } from '../../../utils';

const initialLineStatus = {
    queued: 0,
    queuedCount: 0,
    assigned: 0,
    assignedCount: 0,
    rejected: 0,
    rejectedCount: 0,
    verified: 0,
    verifiedCount: 0,
    skipped: 0,
    skippedCount: 0,
    raisedTickets: 0,
    raisedTicketsCount: 0
}


const ProcessLine = (props) => {
    const { processLine, setIsLoading, processLineLastCheckOutAttendanceLogs, setProcessLineLastCheckOutAttendanceLogs } = props
    const { processLineId, processLineName, lineOwnersList, byPassApproverList, usersList, selfCheckOut, autoCheckOutEOD } = processLine

    const dispatch = useDispatch()

    const verifiedPIItems = useSelector(state => state.processLineItems.verifiedPIItems)
    const processLineItemsData = useSelector(state => state.processLineItems.processLineItemsData)
    const processLineStatusList = useSelector(state => state.processLineStatus.processLineStatusData)

    const userDetails = useSelector(state => state.userDetails)
    const pmCompanyUsers = userDetails.PMCompanyDetails.companyUsers

    const [lineStatus, setLineStatus] = useState(initialLineStatus)

    useEffect(() => {
        if (processLineItemsData?.length > 0) {
            let newStatusCounts = {...initialLineStatus}

            const relatedProcessLineItems = processLineItemsData.filter(each => each.processLineId === processLineId)

            relatedProcessLineItems.forEach(item => {
                const relatedCount = parseInt(item.relatedPIPunchItemCount)

                if (item.itemQueued) {
                    newStatusCounts.queued += 1
                    newStatusCounts.queuedCount += relatedCount
                }
                if (item.itemAssigned) {
                    newStatusCounts.assigned += 1
                    newStatusCounts.assignedCount += relatedCount
                }
                if (item.itemRejected) {
                    newStatusCounts.rejected += 1
                    newStatusCounts.rejectedCount += relatedCount
                }
                if (item.itemSkipped) {
                    newStatusCounts.skipped += 1
                    newStatusCounts.skippedCount += relatedCount
                }
                if (item.itemRaisedIssues) {
                    newStatusCounts.raisedTickets += 1
                    newStatusCounts.raisedTicketsCount += relatedCount
                }
            })

            newStatusCounts.verified = verifiedPIItems.reduce((sum, item) => sum + parseInt(item.verifiedPI), 0)
            newStatusCounts.verifiedCount = verifiedPIItems.reduce((sum, item) => sum + parseInt(item.relatedPIItemsCount), 0)

            setLineStatus(newStatusCounts)
        }
    }, [processLineItemsData])

    const handleRefreshClick = async () => {
        setIsLoading(true)

        const todayDate = new Date()
        todayDate.setHours(0, 0, 0, 0)
        const processLineItemsParams = {
            date: todayDate.toISOString(),
        }
        const response = await getProcessLineItemsByProcessLineId(processLineId, processLineItemsParams)
        setIsLoading(false)

        if (response.failure) {
            return dispatch(raiseToast({ severity: 'error', summary: "CheckIn", detail: response.data.error, life: 3000 }))
        } else {
            let newStatusCounts = {...initialLineStatus}

            response.data.processLineItems.forEach(item => {
                const relatedCount = parseInt(item.relatedPIPunchItemCount)
                if (item.itemQueued) {
                    newStatusCounts.queued += 1
                    newStatusCounts.queuedCount += relatedCount
                }
                if (item.itemAssigned) {
                    newStatusCounts.assigned += 1
                    newStatusCounts.assignedCount += relatedCount
                }
                if (item.itemRejected) {
                    newStatusCounts.rejected += 1
                    newStatusCounts.rejectedCount += relatedCount
                }
                if (item.itemSkipped) {
                    newStatusCounts.skipped += 1
                    newStatusCounts.skippedCount += relatedCount
                }
                if (item.itemRaisedIssues) {
                    newStatusCounts.raisedTickets += 1
                    newStatusCounts.raisedTicketsCount += relatedCount
                }
            })

            newStatusCounts.verified = response.data.verifiedPIItems.reduce((sum, item) => sum + parseInt(item.verifiedPI), 0)
            newStatusCounts.verifiedCount = response.data.verifiedPIItems.reduce((sum, item) => sum + parseInt(item.relatedPIItemsCount), 0)

            let updatedProcessLineItems = JSON.parse(JSON.stringify(processLineItemsData))
            response.data.processLineItems.forEach(eachItem => {
                const relatedIndex = updatedProcessLineItems.findIndex(each => each.processLineItemId === eachItem.processLineItemId && each.processLineId === processLineId);
                if (relatedIndex !== -1) {
                    updatedProcessLineItems[relatedIndex] = eachItem
                }
            })
            dispatch(updateVerifiedPIItems(response.data.verifiedPIItems))
            dispatch(updateProcessLineItems(updatedProcessLineItems))
            setLineStatus(newStatusCounts)
        }
    }

    const getUserDetailsById = (userId) => {
        return pmCompanyUsers.find(user => user.userId === userId)
    }

    const handleUpdateProcessLineStatus = async (userId, processLineId, relatedProcessLineStatus, relatedLastCheckOutLog) => {
        let data = {}
        if (!relatedProcessLineStatus) {
            data = {
                userId: userId,
                processLineId: processLineId,
                checkInTS: new Date(),
                checkOutTS: null,
                currentStatus: true,
                createdAt: new Date()
            }
            if (window.confirm('Are you sure to check-In?')) {
                setIsLoading(true)
                const addProcessLineStatusRes = await insertProcessLineStatus(data)
                setIsLoading(false)
                if (!addProcessLineStatusRes.failure) {
                    const relatedStatusIndex = processLineStatusList.findIndex(eachStatus => 
                        eachStatus.processLineId === processLineId && eachStatus.userId === userId
                    )
                    const updateProcessLineStatusList = [...processLineStatusList]
                    if (relatedStatusIndex !== -1) {
                        updateProcessLineStatusList[relatedStatusIndex] = {
                            ...updateProcessLineStatusList[relatedStatusIndex], 
                            checkInTS: new Date(), 
                            checkOutTS: null, 
                            currentStatus: true
                        }
                    } else {
                        updateProcessLineStatusList.push(addProcessLineStatusRes.data)
                    }

                    dispatch(updateProcessLineStatus(updateProcessLineStatusList))
                    return dispatch(raiseToast({ severity: 'success', summary: "CheckIn", detail: 'Check In Successful.', life: 3000 }))
                } else {
                    return dispatch(raiseToast({ severity: 'error', summary: "CheckIn", detail: addProcessLineStatusRes.data.error, life: 3000 }))
                }
            }

        } else {
            let processLineStatusId
            let confirmMsg = "Are you sure to check-In?"
            if (relatedProcessLineStatus && relatedProcessLineStatus.currentStatus) {
                processLineStatusId = relatedProcessLineStatus.processLineStatusId
                data = {
                    userId: userId,
                    processLineId: processLineId,
                    checkInTS: relatedProcessLineStatus.checkInTS,
                    checkOutTS: new Date(),
                    currentStatus: false,
                    checkInDate: relatedProcessLineStatus.checkInTS,
                    checkOutBy: userDetails.userId,
                    lastCheckoutLog: relatedLastCheckOutLog
                }
                confirmMsg = "Are you sure to Check-Out?"
            }
            else {
                processLineStatusId = relatedProcessLineStatus.processLineStatusId
                data = {
                    userId: userId,
                    processLineId: processLineId,
                    checkInTS: new Date(),
                    checkOutTS: null,
                    currentStatus: true
                }
            }
            if (window.confirm(confirmMsg)) {
                setIsLoading(true)
                const updateCheckinStatusRes = await updateProcessLineCheckInStatus(processLineStatusId, data)
                setIsLoading(false)
                if (updateCheckinStatusRes.failure) {
                    return dispatch(raiseToast({ severity: 'error', summary: data.currentStatus ? "Update Check-In Status" : "Update Check-Out Status", detail: updateCheckinStatusRes.data.error, life: 3000 }))
                } else {
                    const updateProcessLineStatusList = processLineStatusList.map(eachStatus => {
                        if (eachStatus.processLineId === processLineId && eachStatus.userId === userId && data.currentStatus) {
                            return {
                                ...eachStatus,
                                checkInTS: new Date(), checkOutTS: null, currentStatus: true
                            }
                        } else if (eachStatus.processLineId === processLineId && eachStatus.userId === userId && !data.currentStatus) {
                            return {
                                ...eachStatus,
                                checkInTS: data.checkInTS, checkOutTS: data.checkOutTS, currentStatus: false, checkInDate: data.checkInDate, checkOutBy: data.checkOutBy
                            }
                        }
                        return eachStatus
                    })
                    dispatch(updateProcessLineStatus(updateProcessLineStatusList))
                    if (!data.currentStatus && updateCheckinStatusRes.data) {
                        let updateLastCheckOutLogs = processLineLastCheckOutAttendanceLogs.map(eachLog => {
                            if (eachLog.userId === userId && eachLog.processLineId === processLineId && eachLog.processLineAttendanceLogId === relatedLastCheckOutLog.processLineAttendanceLogId) {
                                return {
                                    ...eachLog, statusId: 2
                                }
                            }
                            return eachLog
                        })
                        updateLastCheckOutLogs = [...updateLastCheckOutLogs, updateCheckinStatusRes.data]
                        setProcessLineLastCheckOutAttendanceLogs(updateLastCheckOutLogs)
                    }
                    return dispatch(raiseToast({ severity: 'success', detail: data.currentStatus ? 'Check-In Successful.' : 'Check-Out Successful', life: 3000 }))
                }
            }
        }
    }

    const userLineStatus = processLineStatusList.find(eachStatus => eachStatus.userId === userDetails.userId && usersList.includes(userDetails.userId) && eachStatus.processLineId === processLineId)
    const userLastCheckOutLog = processLineLastCheckOutAttendanceLogs.find(eachLastCheckOutLog => eachLastCheckOutLog.userId === userDetails.userId && usersList.includes(userDetails.userId) && eachLastCheckOutLog.processLineId === processLineId)
    const canCheckOut = lineOwnersList.includes(userDetails.userId) || selfCheckOut

    return (
        <div className="process-lines p-card p-0 md:mx-7 md:my-3">
            <div className="p-card-header">
                {processLineName}
            </div>
            <div className="p-card-body">
                <div className="flex flex-row justify-content-between align-items-center">
                    <div className="flex flex-row align-items-center line-status-info">
                        <div className="status-box flex-1 p-2 queued-card ml-2">
                            <h3 className="font-bold text-center mb-1 text-gray-700 text-xs m-0 flex items-center justify-center gap-1">
                                QUEUED:
                                <i className="pi pi-info-circle custom-tooltip-queued" aria-hidden="true"></i>
                            </h3>
                            <h3 className="text-center mb-1 text-gray-700 text-xs m-0">
                                {lineStatus.queued}({lineStatus.queuedCount})
                            </h3>
                            <Tooltip target=".custom-tooltip-queued" position="top" autoHide>
                                Total invoices currently pending in the queue for verification today (Number of related invoice items).
                            </Tooltip>
                        </div>

                        <div className="status-box flex-1 p-2 assigned-card ml-2">
                            <h3 className="font-bold text-center mb-1 text-gray-700 text-xs m-0 flex items-center justify-center gap-1">
                                ASSIGNED:
                                <i className="pi pi-info-circle custom-tooltip-assigned" aria-hidden="true"></i>
                            </h3>
                            <h3 className="text-center mb-1 text-gray-700 text-xs m-0">
                                {lineStatus.assigned}({lineStatus.assignedCount})
                            </h3>
                            <Tooltip target=".custom-tooltip-assigned" position="top" autoHide>
                                Total today's invoices assigned to the line users but without any issues raised (Number of related invoice items).
                            </Tooltip>
                        </div>

                        <div className="status-box flex-1 p-2 verified-card ml-2">
                            <h3 className="font-bold text-center mb-1 text-gray-700 text-xs m-0 flex items-center justify-center gap-1">
                                VERIFIED:
                                <i className="pi pi-info-circle custom-tooltip-verified" aria-hidden="true"></i>
                            </h3>
                            <h3 className="text-center mb-1 text-gray-700 text-xs m-0">
                                {lineStatus.verified}({lineStatus.verifiedCount})
                            </h3>
                            <Tooltip target=".custom-tooltip-verified" position="top" autoHide>
                                Total verified invoices today (Number of related invoice items).
                            </Tooltip>
                        </div>

                        <div className="status-box flex-1 p-2 rejected-card ml-2">
                            <h3 className="font-bold text-center mb-1 text-gray-700 text-xs m-0 flex items-center justify-center gap-1">
                                REJECTED:
                                <i className="pi pi-info-circle custom-tooltip-rejected" aria-hidden="true"></i>
                            </h3>
                            <h3 className="text-center mb-1 text-gray-700 text-xs m-0">
                                {lineStatus.rejected}({lineStatus.rejectedCount})
                            </h3>
                            <Tooltip target=".custom-tooltip-rejected" position="top" autoHide>
                                Total today's invoices where an issue has been raised (Number of related invoice items).
                            </Tooltip>
                        </div>

                        <div className="status-box flex-1 p-2 skipped-card ml-2">
                            <h3 className="font-bold text-center mb-1 text-gray-700 text-xs m-0 flex items-center justify-center gap-1">
                                SKIPPED:
                                <i className="pi pi-info-circle custom-tooltip-skipped" aria-hidden="true"></i>
                            </h3>
                            <h3 className="text-center mb-1 text-gray-700 text-xs m-0">
                                {lineStatus.skipped}({lineStatus.skippedCount})
                            </h3>
                            <Tooltip target=".custom-tooltip-skipped" position="top" autoHide>
                                Total skipped invoices today (Number of related invoice items).
                            </Tooltip>
                        </div>

                        <div className="status-box flex-1 p-2 tickets-card ml-2">
                            <h3 className="font-bold text-center mb-1 text-gray-700 text-xs m-0 flex items-center justify-center gap-1">
                                TICKETS:
                                <i className="pi pi-info-circle custom-tooltip-tickets" aria-hidden="true"></i>
                            </h3>
                            <h3 className="text-center mb-1 text-gray-700 text-xs m-0">
                                {lineStatus.raisedTickets}({lineStatus.raisedTicketsCount})
                            </h3>
                            <Tooltip target=".custom-tooltip-tickets" position="top" autoHide>
                                Total invoices with raised tickets, including both today and past dates (Number of related invoice items).
                            </Tooltip>
                        </div>

                        <button className="image-button" onClick={() => handleRefreshClick(userDetails.userId, processLineId, userLineStatus, userLastCheckOutLog)}>
                            <img src={RefreshImg} alt="Refresh" style={{ height: 40, width: 40 }} />
                        </button>
                    </div>

                    {
                        usersList.includes(userDetails.userId) ? (
                            <div className="flex flex-row justify-content-end">
                                {userLineStatus && userLineStatus.currentStatus ? (
                                    <button
                                        className={`${!canCheckOut ? 'opacity-50 cursor-not-allowed' : 'image-button'}`}
                                        onClick={() => canCheckOut && handleUpdateProcessLineStatus(userDetails.userId, processLineId, userLineStatus, userLastCheckOutLog)}
                                        disabled={!canCheckOut}
                                    >
                                        <img
                                            src={CheckOutImg}
                                            alt="Check-Out"
                                            style={{ height: 36, width: 112 }}
                                        />
                                    </button>
                                ) : (
                                    <button
                                        className={`image-button`}
                                        onClick={() => handleUpdateProcessLineStatus(userDetails.userId, processLineId, userLineStatus, userLastCheckOutLog)}
                                        // disabled={!selfCheckOut}
                                    >
                                        <img
                                            src={CheckInImg}
                                            alt="Check-In"
                                            style={{ height: 36, width: 112 }}
                                        />
                                    </button>
                                )}
                            </div>
                        ) : null
                    }
                </div>

                {lineOwnersList.length > 0 && (
                    <div className="flex flex-wrap mt-2">
                        <span className="strong owner-approver-info mr-2">LINE OWNERS:</span>
                        {lineOwnersList.map(userId => {
                            const userDetails = getUserDetailsById(userId)
                            return (
                                <Chip
                                    key={userId}
                                    label={getFullName(userDetails.firstName, userDetails.lastName)}
                                    image={userImage}
                                    className="mr-2 mb-2"
                                />
                            )
                        })}
                    </div>
                )}

                <div className="flex flex-row m-0 justify-content-between">
                    <div className="flex flex-wrap mb-1 mt-2">
                        <span className="strong owner-approver-info mr-2">BY-PASS APPROVERS:</span>
                        {byPassApproverList.map(userId => {
                            const userDetails = getUserDetailsById(userId)
                            return (
                                <Chip
                                    key={userId}
                                    label={getFullName(userDetails.firstName, userDetails.lastName)}
                                    image={userImage}
                                    className="mr-2 mb-2"
                                />
                            )
                        })}
                    </div>
                    <div className="flex flex-row justify-content-end mt-1">
                        {
                            selfCheckOut ?
                                <div className="flex-column">
                                    <span className="custom-label checkout-options">Self Check-Out</span>
                                </div>
                                : null
                        }
                        {
                            autoCheckOutEOD ?
                                <div className="flex-column ml-5">
                                    <span className="custom-label checkout-options ml-2">Auto Check-Out EOD</span>
                                </div>
                                : null
                        }

                    </div>
                </div>

                <div className='hr-line' />

                <p className="mb-0">Process Line Users:</p>
                <div className="custom-table-container">
                    <table className="custom-product-table">
                        <thead>
                            <tr>
                                <th className="">User Name</th>
                                <th className="">Check-In Status</th>
                                <th className="">Work Status</th>
                                <th className="">Last Check-In</th>
                                <th className="">Last Check-Out</th>
                            </tr>
                        </thead>
                        <tbody>
                            {usersList.map(userId => {
                                const relatedUserDetails = pmCompanyUsers.find(user => user.userId === userId)
                                const userName = getFullName(relatedUserDetails.firstName, relatedUserDetails.lastName)
                                const relatedLastCheckOutLog = processLineLastCheckOutAttendanceLogs.find(eachLastCheckOutLog => eachLastCheckOutLog.userId === userId && eachLastCheckOutLog.processLineId === processLineId && eachLastCheckOutLog.statusId === 1)
                                const relatedProcessLineStatus = processLineStatusList.find(eachStatus => eachStatus.userId === userId && eachStatus.processLineId === processLineId)

                                const relatedProcessLineItems = processLineItemsData.filter(eachProcessLineItem => eachProcessLineItem.processLineId === processLineId && eachProcessLineItem.assigneeId === userId)

                                const assignedCount = relatedProcessLineItems.filter(eachRelatedProcessLineItem => eachRelatedProcessLineItem.itemAssigned).length
                                const rejectedCount = relatedProcessLineItems.filter(eachRelatedProcessLineItem => eachRelatedProcessLineItem.itemRejected).length

                                const assignedRelatedCount = relatedProcessLineItems.filter(eachRelatedProcessLineItem => eachRelatedProcessLineItem.itemAssigned)
                                    .reduce((sum, item) => sum + parseInt(item.relatedPIPunchItemCount), 0)

                                const rejectedRelatedCount = relatedProcessLineItems.filter(eachRelatedProcessLineItem => eachRelatedProcessLineItem.itemRejected)
                                    .reduce((sum, item) => sum + parseInt(item.relatedPIPunchItemCount), 0)

                                const relatedUserVerifiedItem = verifiedPIItems?.find(eachVerifiedItem => eachVerifiedItem.userId === userId)

                                const canEdit = (lineOwnersList.includes(userDetails.userId) && relatedProcessLineStatus?.currentStatus)
                                    || (userId === userDetails.userId && !relatedProcessLineStatus?.currentStatus)
                                    || (userId === userDetails.userId && selfCheckOut && relatedProcessLineStatus?.currentStatus)

                                return (
                                    <tr key={userId}>
                                        <td className="">{userName}</td>
                                        <td className=""><InputSwitchField onChange={() => handleUpdateProcessLineStatus(userId, processLineId, relatedProcessLineStatus, relatedLastCheckOutLog)} checked={relatedProcessLineStatus?.currentStatus} disabled={!canEdit} /></td>
                                        <td className="">
                                            <b><span style={{ color: '#66e466' }}>A</span></b> {assignedCount}({assignedRelatedCount})
                                            <b> - <span style={{ color: '#ca851e' }}> V</span></b>  {relatedUserVerifiedItem?.verifiedPI}({relatedUserVerifiedItem?.relatedPIItemsCount})
                                            <b> - <span style={{ color: '#a95fef' }}>R</span></b> {rejectedCount}({rejectedRelatedCount})
                                        </td>
                                        <td className="">{relatedProcessLineStatus?.checkInTS ? moment(relatedProcessLineStatus?.checkInTS).format(DATE_TIME_FORMAT) : '-'}</td>
                                        <td className="">{relatedLastCheckOutLog?.checkOutTS ? moment(relatedLastCheckOutLog?.checkOutTS).format(DATE_TIME_FORMAT) : '-'} </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )

}

export default ProcessLine
